import React, {FunctionComponent, useState} from 'react';
import {Field, useFormikContext} from 'formik';

// MUI
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';

// Common
import { GENERAL } from '../../../../constants';

// Components
import { Tile } from '../../../Tile';
import { FormCheckbox } from '../FormInputs';

// Properties
import * as styles from './FormTerms.styles';

const FormTerms: FunctionComponent = () => {
    const { setFieldValue } = useFormikContext();

    const [selectAll, setSelectAll] = useState(false);
    const [marketingAgreement, setMarketingAgreement] = useState(false);
    const [emailAgreement, setEmailAgreement] = useState(false);
    const [callAgreement, setCallAgreement] = useState(false);

    const handleSelectAll = (e: Event) => {
        e.preventDefault();
        const newValue = !selectAll;
        setSelectAll(newValue);
        setMarketingAgreement(newValue);
        setEmailAgreement(newValue);
        setCallAgreement(newValue);

        setFieldValue("marketingAgreement", newValue);
        setFieldValue("emailAgreement", newValue);
        setFieldValue("callAgreement", newValue);
    };

    return (
        <Tile>
            <Box>
                <Typography variant="caption" sx={styles.description}>
                    {GENERAL.TERMS_DESCRIPTION}
                </Typography>
                <Field
                    name="selectAll"
                    label={GENERAL.TERMS_SELECT_ALL}
                    component={FormCheckbox}
                    checked={selectAll}
                    onClick={(e: Event) => handleSelectAll(e)}
                />
                <Box sx={styles.group}>
                    <Field
                        name="marketingAgreement"
                        label={GENERAL.TERMS_MARKETING}
                        component={FormCheckbox}
                        checked={marketingAgreement}
                        onClick={() => {
                            setMarketingAgreement(!marketingAgreement);
                            setFieldValue("marketingAgreement", !marketingAgreement);
                        }}
                    />
                    <Field
                        name="emailAgreement"
                        label={GENERAL.TERMS_EMAIL}
                        component={FormCheckbox}
                        checked={emailAgreement}
                        onClick={() => {
                            setEmailAgreement(!emailAgreement);
                            setFieldValue("emailAgreement", !emailAgreement);
                        }}
                    />
                    <Field
                        name="callAgreement"
                        label={GENERAL.TERMS_CALL}
                        component={FormCheckbox}
                        checked={callAgreement}
                        onClick={() => {
                            setCallAgreement(!callAgreement);
                            setFieldValue("callAgreement", !callAgreement);
                        }}
                    />
                    <Typography sx={styles.caption} variant="caption">
                        {GENERAL.REQUIRED}
                    </Typography>
                </Box>
            </Box>
            <Box>
                <Accordion
                    disableGutters
                    elevation={0}
                    square
                    sx={styles.accordion}
                >
                    <AccordionSummary sx={styles.summary}>
                        <Typography
                            variant="caption"
                        >
                            {GENERAL.TERMS_PERSONAL}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={styles.details}>
                        {GENERAL.TERMS_INFO.map((info, index) => (
                            <Typography
                                key={index}
                                variant="body2"
                                gutterBottom
                                sx={styles.info}
                            >
                                {info}
                            </Typography>
                        ))}
                        <Typography
                            variant="body2"
                            sx={styles.link}
                        >
                            {GENERAL.TERMS_MARK}
                            <Link
                                underline="none"
                                href={`mailto:${GENERAL.TERMS_GWO_EMAIL}`}
                            >
                                {GENERAL.TERMS_GWO_EMAIL}
                            </Link>
                            {GENERAL.TERMS_GWO_DESCRIPTION}
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={styles.link}
                        >
                            {GENERAL.TERMS_MARK}
                            <Link
                                underline="none"
                                href={`mailto:${GENERAL.TERMS_IRE_EMAIL}`}
                            >
                                {GENERAL.TERMS_IRE_EMAIL}
                            </Link>
                            {GENERAL.TERMS_IRE_DESCRIPTION}
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Box>
            <Box>
                <Divider sx={styles.divider} />
                <Typography variant="caption" sx={styles.description}>
                    {GENERAL.TERMS_ADMINS}
                </Typography>
            </Box>
        </Tile>
    );
};

export default FormTerms;
